(() => {
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const trap = (dialog) => {
    const nodes = [...dialog.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')];
    if (!nodes.length) return () => {};
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    dialog.addEventListener('keydown', handler);
    return () => dialog.removeEventListener('keydown', handler);
  };

  document.querySelectorAll('[data-dialog]').forEach((btn) => {
    const dlg = document.getElementById(btn.getAttribute('aria-controls') || btn.dataset.dialog);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    let release = () => {};
    on(btn, 'click', () => {
      dlg.showModal();
      release = trap(dlg);
      const closeBtn = dlg.querySelector('[data-close]');
      if (closeBtn) closeBtn.focus();
    });
    on(dlg, 'close', () => release());
    dlg.querySelectorAll('[data-close]').forEach((c) => on(c, 'click', () => dlg.close()));
    on(dlg, 'click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  });

  let cartQueue = Promise.resolve();
  const enqueueCart = (fn) => {
    cartQueue = cartQueue.then(fn).catch(() => {});
    return cartQueue;
  };

  const cartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  };

  const openCart = () => {
    const dlg = document.getElementById('CartDrawer');
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
  };

  const rebindQty = (scope) => {
    scope.querySelectorAll('[data-qty]').forEach((el) => {
      delete el.dataset.qtyBound;
    });
    qtyForms(scope);
  };

  const refreshCart = async () => {
    const res = await fetch(`${root()}?section_id=cart-drawer`);
    if (res.ok) {
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('CartDrawer');
      const current = document.getElementById('CartDrawer');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        rebindQty(current);
        current.querySelectorAll('[data-close]').forEach((c) => on(c, 'click', () => current.close()));
      }
      const countEl = doc.querySelector('[data-cart-count]');
      if (countEl) cartCount(countEl.textContent.trim());
    }
    await refreshCartPage();
  };

  const refreshCartPage = async () => {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    const sid = page.dataset.sectionId || 'main';
    const res = await fetch(`${root()}cart?section_id=${encodeURIComponent(sid)}`);
    if (!res.ok) return;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-page]');
    if (!fresh) return;
    page.innerHTML = fresh.innerHTML;
    rebindQty(page);
  };

  const changeCart = async ({ id, quantity }) => {
    const res = await fetch(`${root()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity: Number(quantity) }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Impossible de mettre à jour le panier');
    }
    await refreshCart();
  };

  const lineKeyFrom = (wrap) => {
    if (wrap.dataset.lineKey) return wrap.dataset.lineKey;
    const form = wrap.closest('form[data-ajax="cart-update"]');
    return form?.querySelector('input[name="id"]')?.value || '';
  };

  const qtyForms = (scope = document) => {
    scope.querySelectorAll('[data-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      if (!input || wrap.dataset.qtyBound) return;
      wrap.dataset.qtyBound = 'true';
      const min = input.min === '' ? 1 : Number(input.min);
      const apply = () => {
        let qty = Number(input.value);
        if (Number.isNaN(qty)) qty = Math.max(min, 1);
        qty = Math.max(min, qty);
        input.value = String(qty);
        const lineId = lineKeyFrom(wrap);
        if (!lineId) return;
        wrap.querySelectorAll('button, input').forEach((el) => {
          el.disabled = true;
        });
        enqueueCart(async () => {
          try {
            await changeCart({ id: lineId, quantity: qty });
          } catch (err) {
            wrap.querySelectorAll('button, input').forEach((el) => {
              el.disabled = false;
            });
          }
        });
      };
      wrap.querySelectorAll('button').forEach((b) => {
        on(b, 'click', (e) => {
          e.preventDefault();
          const step = b.dataset.dir === 'down' ? -1 : 1;
          input.value = String(Math.max(min, Number(input.value || 0) + step));
          apply();
        });
      });
      on(input, 'change', apply);
    });
  };
  qtyForms();

  const bundleTakesOver = (form) => {
    if (!form || form.dataset.skipAjax === 'true') return true;
    return Boolean(
      form.querySelector('[name^="items["], [name="items[]"]') ||
        document.querySelector(
          '.kaching-bundles, [class*="kaching-bundles"], [id*="kaching-bundles"], [data-kaching-bundles-id], kaching-bundles'
        )
    );
  };

  const addToCart = async (payload) => {
    const isForm = typeof FormData !== 'undefined' && payload instanceof FormData;
    const res = await fetch(`${root()}cart/add.js`, {
      method: 'POST',
      headers: isForm
        ? { Accept: 'application/json' }
        : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm
        ? payload
        : JSON.stringify(payload.items ? payload : { id: Number(payload.id), quantity: Number(payload.quantity || 1) }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Impossible d’ajouter au panier');
    }
    await refreshCart();
    if (document.body.dataset.autoOpenCart === 'true') openCart();
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.dataset.productForm === 'true' || form.dataset.ajax === 'cart' || (form.getAttribute('action') || '').includes('/cart/add')) {
      if (bundleTakesOver(form) || e.defaultPrevented) return;
      e.preventDefault();
      const formData = new FormData(form);
      const idInput = form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]');
      if (idInput && idInput.value) formData.set('id', idInput.value);
      if (!formData.get('quantity')) formData.set('quantity', '1');
      const id = formData.get('id');
      const btn = form.querySelector('[data-add]');
      if (!id) return;
      if (btn) btn.disabled = true;
      try {
        await addToCart(formData);
      } catch (err) {
        form.submit();
        return;
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.inStock || btn.textContent;
        }
      }
    }

    if (form.dataset.ajax === 'cart-update') {
      e.preventDefault();
      const id = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || '0';
      if (!id) return;
      enqueueCart(() => changeCart({ id, quantity }));
    }
  });

  const searchInput = document.querySelector('[data-predictive-search]');
  const results = document.querySelector('[data-predictive-results]');
  let t;
  if (searchInput && results) {
    on(searchInput, 'input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      t = setTimeout(async () => {
        const res = await fetch(
          `${root()}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`
        );
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-predictive-results]');
        results.innerHTML = inner ? inner.innerHTML : '';
      }, 180);
    });
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const setMain = (src, srcset) => {
      const wrap = gallery.querySelector('[data-gallery-main]');
      const img = wrap && wrap.querySelector('img');
      if (!img || !src) return;
      img.src = src;
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('sizes', '(min-width: 900px) 50vw, 100vw');
    };
    gallery.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-gallery-thumb]');
      if (!btn || !gallery.contains(btn)) return;
      e.preventDefault();
      setMain(btn.dataset.src, btn.dataset.srcset);
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((b) => b.setAttribute('aria-current', 'false'));
      btn.setAttribute('aria-current', 'true');
    });
  });

  document.querySelectorAll('[data-timer]').forEach((el) => {
    const hours = Number(el.dataset.hours || 0);
    if (!hours) return;
    const span = el.querySelector('span') || el;
    const key = 'ray-timer-' + location.pathname;
    let end = Number(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      localStorage.setItem(key, String(end));
    }
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const s = Math.floor(left / 1000);
      const hh = String(Math.floor(s / 3600)).padStart(2, '0');
      const mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      const ss = String(s % 60).padStart(2, '0');
      span.textContent = `${hh}:${mm}:${ss}`;
    };
    tick();
    setInterval(tick, 1000);
  });

  const sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    const product = document.getElementById('product');
    const io = new IntersectionObserver(
      (entries) => {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      },
      { threshold: 0.05 }
    );
    if (product) io.observe(product);
    on(sticky.querySelector('[data-sticky-add]'), 'click', () => {
      const add = document.querySelector('[data-add]');
      if (add) add.click();
    });
  }

  const bindVariantForm = (form) => {
    const jsonEl = form.querySelector('[data-variant-json]');
    if (!jsonEl || form.dataset.variantBound === 'true') return;
    if (!form.querySelector('[data-option]')) return;
    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;
    form.dataset.variantBound = 'true';

    const optionNames = () => {
      const names = [];
      form.querySelectorAll('[data-option]').forEach((el) => {
        if (el.name && !names.includes(el.name)) names.push(el.name);
      });
      return names;
    };

    const selectedOptions = () =>
      optionNames().map((name) => {
        const sample = form.querySelector(`[data-option][name="${name}"]`);
        if (sample && sample.type === 'radio') {
          const checked = form.querySelector(`[data-option][name="${name}"]:checked`);
          return (checked?.value || '').trim();
        }
        return (sample?.value || '').trim();
      });

    const setVariantId = (id) => {
      form.querySelectorAll('[name="id"], [data-variant-id]').forEach((el) => {
        el.value = String(id);
      });
    };

    const sync = () => {
      const current = selectedOptions();
      if (!current.length || current.some((v) => !v)) return;
      const match = variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === current.length &&
          v.options.every((o, i) => String(o).trim() === current[i])
      );
      if (!match) return;
      setVariantId(match.id);
      document.querySelectorAll('[data-price]').forEach((price) => {
        if (match.price_html) price.innerHTML = match.price_html;
      });
      const btn = form.querySelector('[data-add]');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.inStock : btn.dataset.soldOut;
      }
    };

    form.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('[data-option]')) sync();
    });
    form.querySelectorAll('.variant-options label').forEach((label) => {
      on(label, 'click', () => {
        const input = label.htmlFor ? form.querySelector(`#${CSS.escape(label.htmlFor)}`) : null;
        if (input && input.type === 'radio' && !input.checked) {
          input.checked = true;
        }
        sync();
      });
    });
    sync();
  };

  document.querySelectorAll('form[data-product-form="true"]').forEach(bindVariantForm);
  document.querySelectorAll('[data-variant-json]').forEach((el) => {
    const form = el.closest('form');
    if (form) bindVariantForm(form);
  });
})();
